export default {
  ALL: "CF_ALL",
  INVOLVED: "CF_INVOLVED",
  RESPONSIBLE: "CF_RESPONSIBLE",
  OWNER: "CF_OWNER",
  RESPONSIBLE_OR_INVOLVED: "CF_RESPONSIBLE_OR_INVOLVED",
  RESPONSIBLE_OR_OWNER: "CF_RESPONSIBLE_OR_OWNER",
  INVOLVED_OR_OWNER: "CF_INVOLVED_OR_OWNER"
};
